export type CurrencyType = 643

export enum Currencies {
  RUB = 643,
  USD = 840,
  USDT = 10001,
}

export enum CryptoCurrencies {
  Tron = 1,
  Bsc = 2,
  Eth = 3,
}

export enum CurrenciesProvider {
  ByBit = 0,
  Rapira = 1,
}

